const skills3d = [
    { text: 'Blender', icon: 'skill_advanced.png'},
    { text: 'ZBrush', icon: 'skill_intermediate.png'},
    { text: 'Maya', icon: 'skill_beginner.png'},
  ];
  
  export default skills3d;